import { render, staticRenderFns } from "./couserViewnew.vue?vue&type=template&id=55f714df&scoped=true"
import script from "./couserViewnew.vue?vue&type=script&lang=js"
export * from "./couserViewnew.vue?vue&type=script&lang=js"
import style0 from "./couserViewnew.vue?vue&type=style&index=0&id=55f714df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f714df",
  null
  
)

export default component.exports